module.exports = __webpack_public_path__ + "static/media/Icon ionic-ios-warning.c8a8afea.svg";